import useId from '../utils/useId';
import * as React from 'react';
export const weroSvg = React.forwardRef(function weroSvgInner(props, ref) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.211 7.91c0-.997.694-1.906 1.892-1.906 1.203 0 1.897.91 1.897 1.907s-.694 1.906-1.897 1.906c-1.198 0-1.892-.91-1.892-1.906Zm2.736 0c0-.48-.31-.924-.844-.924-.529 0-.843.444-.843.925 0 .48.314.925.843.925.534 0 .844-.445.844-.925Zm-3.472.709c.4-.233.639-.677.639-1.168 0-.729-.514-1.35-1.313-1.35H9.124V9.72h1.038v-.925h.195l.594.925h1.223l-.699-1.1Zm-.883-.657h-.43V6.94h.435c.28 0 .459.233.459.512s-.185.511-.464.511ZM4.384 6.098l-.623 2.156-.607-2.156h-.827l-.613 2.156-.618-2.156H0l1.255 3.61h.902l.583-1.965.578 1.966h.907L5.48 6.098H4.384Zm2.667 2.729H7.05c-.389 0-.66-.24-.778-.558H8.91a2.12 2.12 0 0 0 .032-.366c0-.994-.692-1.902-1.89-1.903v.98c.39.001.66.24.775.558H5.192c-.02.12-.031.242-.031.366 0 .995.692 1.903 1.888 1.903h.002v-.98Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.049 9.807a1.983 1.983 0 0 0 .78-.148 1.741 1.741 0 0 0 .878-.8 1.96 1.96 0 0 0 .187-.511h-1.1a.82.82 0 0 1-.405.409.8.8 0 0 1-.34.07.789.789 0 0 1-.59-.25l-.715.74c.317.3.758.49 1.305.49Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.049 6c-1.014 0-1.666.653-1.841 1.459h1.096a.802.802 0 0 1 .745-.479c.283 0 .503.125.647.315l.721-.747C8.095 6.214 7.632 6 7.05 6Z',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `pm_wero__a_${id_0}`,
          x1: 8.341,
          y1: 7.678,
          x2: 6.654,
          y2: 9.696,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.024,
          stopColor: '#474E5A',
          stopOpacity: 0,
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.676,
          stopColor: '#474E5A',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `pm_wero__b_${id_1}`,
          x1: 5.51,
          y1: 8.143,
          x2: 7.231,
          y2: 6.482,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.024,
          stopColor: '#474E5A',
          stopOpacity: 0,
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.676,
          stopColor: '#474E5A',
        }),
      ),
    ),
  );
});
weroSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var wero = {
  category: 'paymentmethod',
  colorable: true,
  name: 'wero',
  svg: weroSvg,
};
